/**
  * 商城 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
//  const api = '/home/'
 const api = '/c-api/'
 
 const index = {
    // 商品分类
    goodsType (params) {
        return axios.post('/home/b2c/goodcates', qs.stringify(params))
    },
    // 商品列表
    goodsList (params) {
        return axios.post('/home/b2c/goods', qs.stringify(params))
    },
    // BToB商品列表
    goodsBToBList (params) {
        return axios.post('/home/b2b/goods', qs.stringify(params))
    },
    // 商品详情
    goodsDetail (params) {
        return axios.post('/home/b2c/goodinfo', qs.stringify(params))
    },
    // 获取/添加购物车
    shopCart (params) {
        return axios.post('/home/b2c/addcart', qs.stringify(params))
    },
    // 获取不同规格的价格
    goodsSpecPrice (params) {
        return axios.post('/home/b2c/goodspecprice', qs.stringify(params))
    },
    // 增加或减少购物车里商品数量
    addGoodsNum (params) {
        return axios.post('/home/b2c/addnum', qs.stringify(params))
    },
    // 删除购物车
    delectCart (params) {
        return axios.post('/home/b2c/delcart', qs.stringify(params))
    },
    // 预结算
    prePay (params) {
        return axios.post('/home/b2c/tosettle', qs.stringify(params))
    },
    // 创建订单
    createOrder (params) {
        return axios.post('/home/b2c/createorder', qs.stringify(params))
    },
    // 商品评论列表
    goodsComment (params) {
        return axios.post('/home/b2c/goodcomment', qs.stringify(params))
    },
    // 添加商品评论
    addComment (params) {
        return axios.post('/home/b2c/addcomment', qs.stringify(params))
    },
    // 我的订单列表
    orderList (params) {
        return axios.post('/home/b2c/orderlist', qs.stringify(params))
    },
    // 我的订单详情
    orderDetail (params) {
        return axios.post('/home/b2c/orderinfo', qs.stringify(params))
    },
    // 确认收货 商城订单
    confirmOrder (params) {
        return axios.post('/home/b2c/confirmorder', qs.stringify(params))
    },
    // 取消订单
    cancelOrder (params) {
        return axios.post('/home/b2c/consoleorder', qs.stringify(params))
    },
    // 退货处理
    returnGoods (params) {
        return axios.post('/home/b2c/returngood', qs.stringify(params))
    },
    // 退货商品信息
    returnGoodsInfo (params) {
        return axios.post('/home/b2c/returngoodinfo', qs.stringify(params))
    },
    // 获取所有规格
    goodsSpec (params) {
        return axios.post('/home/b2c/goodspec', qs.stringify(params))
    },
    // 收藏/取消收藏商品
    goodsCollection (params) {
        return axios.post('/home/b2c/collect', qs.stringify(params))
    },
    // 支付
    goodsPay (params) {
        return axios.post('/home/b2c/topay', qs.stringify(params))
    },
    // 直接购买，进入结算
    goodsSettle (params) {
        return axios.post('/home/b2c/direct/addsettle', qs.stringify(params))
    },
    // 直接购买，进入支付
    goodsBuy (params) {
        return axios.post('/home/b2c/direct/addorder', qs.stringify(params))
    },
    // 专题详情
    specialDetail (params) {
        return axios.get('/home/special/info', {params,params})
    },
    // B2B商城筛选信息
    bTobCateInfo (params) {
        return axios.get('/home/b2c/goodsSearchBasicInfo', {params,params})
	},
	// 我的提货订单
	ztorderlist(params){
		return axios.post('/home/b2c/ztorderlist', qs.stringify(params))
    },
    //邮费
    fare(params) {
        return axios.post('/home/b2c/fare', qs.stringify(params))
	},
	// 确认收货 云支付
    confirmOrderYun (params) {
        return axios.post('/miniprogram/order/receipt', qs.stringify(params))
	},
	// 旧商品详情
	oldgoods (params) {
        return axios.get('/home/b2c/oldgoods', {params,params})
	},
	// 获取支付信息，每种支付方式支付多少钱
	paymoney (params) {
		return axios.get('/home/b2c/paymoney', {params,params})
	},
	// 商品追溯码
	tracecode(params){
		return axios.get('/home/b2c/blockchainlog', {params,params})
	},
	// 商品订单快照
	orderphoto(params){
		return axios.get('/home/goodorder/photo', {params,params})
	},
	// 新退货流程
	ordernewreturn(params){
		return axios.post('/home/b2c/newreturn', qs.stringify(params))
	},
	// 填写退货物流信息
	returnlogistics(params){
		return axios.post('/home/b2c/returnlogistics', qs.stringify(params))
	},
	// 退货订单详情
	returndetail(params){
		return axios.get('/home/b2c/returndetail', {params,params})
	},
	// 向平台申诉退款
	shensureturn(params){
		return axios.post('/home/b2c/shensureturn', qs.stringify(params))
	},
	// 退货状态
	returnstatus(params){
		return axios.get('/home/b2c/returnstatus', {params,params})
	},
	// 用户取消售后
	quxiaoreturn(params){
		return axios.post('/home/b2c/quxiaoreturn', qs.stringify(params))
	},
	// 商品订单
	goodorderinfo(params){
		return axios.get('/home/b2c/goodorderinfo', {params,params})
	},
	// i一起取消订单
	canceliyiqiorder(params){
		return axios.post('/home/b2c/canceliyiqiorder', qs.stringify(params))
	}
 }
 
 // 导出接口
 export default index